import { Box, Button, Modal, Text } from "@modernatx-internal/component-library";
import React, { useEffect, useState } from "react";

import { ContentComponentProps, PrescribingInfoModalContent } from "../types";

export const PrescribingInfoModal: React.FC<ContentComponentProps<PrescribingInfoModalContent>> = ({
  heading,
  body,
  sessionKey,
  buttonText = "Okay"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    if (!sessionKey || !window.sessionStorage.getItem(sessionKey)) {
      setIsOpen(true);
    }
  }, [sessionKey]);

  const handleClose = () => {
    setIsOpen(false);
    if (typeof window !== "undefined" && sessionKey) {
      window.sessionStorage.setItem(sessionKey, "1");
    }
  };

  return (
    <Modal isOpen={isOpen} size="sm" aria-label="prescribing-info-modal" onDismiss={handleClose}>
      <Box>
        <Text as="h2" variant="title-1-medium" sx={{ mb: 4 }}>
          {heading}
        </Text>
        <Text as="p" variant="body-1-regular" sx={{ mb: 8 }}>
          {body}
        </Text>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <Button type="button" onClick={handleClose}>
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
